import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  OffCanvasLayout,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import useCurrency from "./useCurrency";
import EmptyData from "../../Global/EmptyData";
import OrderColumn from "../../Global/OrderColumn";
import { FaSort } from "react-icons/fa";
import CurrencyForm from "./CurrencyForm";
import CurrencyRateForm from "./CurrencyRateForm";

const Currency = () => {
  const {
    mainData,
    handleEditClick,
    isLoading,
    actionOptions,
    handleClearClick,
    currentPage,
    paginationOptions,
    menuState,
    isFetching,
    hasUpdatePermission,
    showCreateModal,
    hasCreatePermission,
    showEditModal,
    showRateEditModal,
    handleSearch,
    handleSort,
    handleEditAction,
    handleCurrencyRateEditAction,
    closeRateEditModal,
    handleCreateClick,
    updateTableFields,
    closeModal,
    refetch,
    closeEditModal,
    handlePagination,
    getRow,
    handleActionChange,
    handlePageSize,
  } = useCurrency();
  return (
    <>
      <HeadingGroup
        title={"Currency"}
        className={`pro-mb-4`}
        buttonTitle={hasCreatePermission === 1 ? "Add new" : ""}
        handleClick={handleCreateClick}
      />

      <div className={`col-auto pro-pt-3 pro-pb-6`}>
        <div className="row">
          <div className="col">
            <SearchFilters
              data={mainData?.data?.filters}
              // onDateChange={handleDateChange}
              onSearchInput={handleSearch}
              showActions={false}
              handleActionClick={handleEditClick}
              loading={isLoading}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
              actionOptions={actionOptions?.filter((item) => item.value === 0)}
              onActionOptionChange={handleActionChange}
              handleClear={handleClearClick}
              searchInputProps={{ value: menuState?.search }}
            />
          </div>
        </div>

        {mainData?.data?.data?.data?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            data={mainData?.data?.data?.data || []}
            uniqueID={"currency_id"}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            showCheckBox={hasUpdatePermission === 1 ? true : false}
            deletable={false}
            handleEdit={handleEditAction}
            assignText={"Rate Margin Edit"}
            assignIcon={<span className="material-symbols-outlined">edit</span>}
            handleAssign={handleCurrencyRateEditAction}
            clear={menuState?.clearSelection}
            multiSelect={false}
            assignable={hasUpdatePermission === 1 ? true : false}
            fields={mainData?.data?.fields}
            SortIcon={<FaSort />}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            perpage={menuState?.currentPageSize}
          />
        )}

        {mainData?.data?.data?.data?.length > 0 && (
          <Pagination
            currentPage={currentPage}
            defaultValue={paginationOptions?.filter(
              (item) => item.value === menuState?.currentPageSize,
            )}
            totalPageCount={mainData?.data?.data?.last_page}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}

        <OffCanvasLayout
          show={showCreateModal}
          handleClose={closeModal}
          title={menuState?.is_edit ? "Update Currency" : "Add Currency"}
          closeIcon={<span className="material-symbols-outlined">close</span>}
          backdrop="static"
        >
          <CurrencyForm refetch={refetch} closeModal={closeModal} />
        </OffCanvasLayout>

        <OffCanvasLayout
          show={showRateEditModal}
          handleClose={closeRateEditModal}
          title={"Currency Edit"}
          closeIcon={<span className="material-symbols-outlined">close</span>}
          backdrop="static"
        >
          <CurrencyRateForm refetch={refetch} closeModal={closeRateEditModal} />
        </OffCanvasLayout>

        <ModalLayout
          show={showEditModal}
          handleClose={closeEditModal}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetch={refetch}
              tableFields={Object.keys(mainData?.data?.fields ?? {}).reduce(
                (filteredObj, property) => {
                  filteredObj[property] = mainData?.data?.fields[property];
                  return filteredObj;
                },
                {},
              )}
              moduleId={mainData?.data?.module_id}
              updateData={updateTableFields}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default Currency;
